import { fixedDigitsValue } from "helpers/dataHelpers";

export const columns = [
  {
    title: "Image",
    dataIndex: "imageURL",
    key: "image",
    width: 80,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
  },
  {
    title: "Price",
    dataIndex: "fiatCentsPrice",
    key: "fiatCentsPrice",
    align: "right" as const,
    sorter: true,
    width: 150,
    render: (value: string) => `${fixedDigitsValue(value, 3)} KWD`,
  },
];
